import { FunctionComponent, SVGProps } from "react";
import Image from "next/image";
import { RiExchangeFill } from "react-icons/ri";

export const BridgeIcon: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 4C18.7449 4.00003 18.9813 4.08996 19.1644 4.25272C19.3474 4.41547 19.4643 4.63975 19.493 4.883L19.5 5V6.565L19.616 6.666L19.893 6.897C19.943 6.939 19.997 6.981 20.051 7.023C20.584 7.438 21.228 7.855 21.816 8.051C21.9406 8.0925 22.0558 8.15814 22.1551 8.24417C22.2544 8.3302 22.3357 8.43494 22.3945 8.5524C22.4533 8.66987 22.4883 8.79776 22.4977 8.92878C22.507 9.0598 22.4905 9.19138 22.449 9.316C22.4075 9.44062 22.3419 9.55585 22.2558 9.65511C22.1698 9.75437 22.0651 9.83571 21.9476 9.89449C21.8301 9.95327 21.7022 9.98834 21.5712 9.99769C21.4402 10.007 21.3086 9.9905 21.184 9.949C20.6821 9.77383 20.2022 9.54093 19.754 9.255L19.5 9.091V14H22.5C22.7549 14.0003 23 14.0979 23.1854 14.2728C23.3707 14.4478 23.4822 14.687 23.4972 14.9414C23.5121 15.1958 23.4293 15.4464 23.2657 15.6418C23.1021 15.8373 22.8701 15.9629 22.617 15.993L22.5 16H19.5V19C19.4997 19.2549 19.4021 19.5 19.2271 19.6854C19.0522 19.8707 18.813 19.9822 18.5586 19.9972C18.3042 20.0121 18.0536 19.9293 17.8582 19.7657C17.6627 19.6021 17.5371 19.3701 17.507 19.117L17.5 19V16H7.49999V19C7.49971 19.2549 7.40211 19.5 7.22714 19.6854C7.05217 19.8707 6.81304 19.9822 6.5586 19.9972C6.30415 20.0121 6.05361 19.9293 5.85816 19.7657C5.66271 19.6021 5.53709 19.3701 5.50699 19.117L5.49999 19V16H2.49999C2.24511 15.9997 1.99996 15.9021 1.81462 15.7272C1.62929 15.5522 1.51776 15.313 1.50282 15.0586C1.48788 14.8042 1.57067 14.5536 1.73426 14.3582C1.89785 14.1627 2.12989 14.0371 2.38299 14.007L2.49999 14H5.49999V9.09C5.00399 9.421 4.42199 9.747 3.81599 9.949C3.69137 9.9905 3.55979 10.007 3.42877 9.99769C3.29775 9.98834 3.16986 9.95327 3.05239 9.89449C2.81516 9.77578 2.6348 9.56769 2.55099 9.316C2.46718 9.06431 2.48679 8.78964 2.6055 8.5524C2.72421 8.31517 2.9323 8.13481 3.18399 8.051C3.77199 7.855 4.41599 7.438 4.94899 7.023L5.10699 6.897L5.38399 6.666L5.49999 6.565V5C5.50027 4.74512 5.59787 4.49997 5.77284 4.31463C5.94781 4.1293 6.18694 4.01777 6.44139 4.00283C6.69583 3.98789 6.94637 4.07067 7.14182 4.23426C7.33728 4.39786 7.46289 4.6299 7.49299 4.883L7.49999 5V6.722C7.76266 7.09774 8.07826 7.43354 8.43699 7.719C9.20999 8.338 10.493 9 12.5 9C14.507 9 15.79 8.338 16.563 7.72C16.956 7.405 17.227 7.094 17.395 6.869L17.5 6.722V5C17.5 4.73478 17.6053 4.48043 17.7929 4.29289C17.9804 4.10536 18.2348 4 18.5 4ZM17.5 9.517C16.9844 9.88396 16.4246 10.1847 15.834 10.412L15.5 10.533V14H17.5V9.517ZM13.5 10.953C12.9426 11.0064 12.3818 11.0151 11.823 10.979L11.5 10.953V14H13.5V10.953ZM7.49999 9.517V14H9.49999V10.533L9.16599 10.413C8.66547 10.2197 8.1868 9.97402 7.73799 9.68L7.49999 9.517Z"
        fill="white"
      />
    </svg>
  );
};

export const AuthIcon: FunctionComponent<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.5 19H14.5M14.5 19V15M14.5 19L19.5 14M5 7.504L1.5 5.504M1.5 5.504L3.5 2M1.5 5.504L8.33 3.634M2.5 14L6.5 13M6.5 13L7.5 17M6.5 13L3 19M19.5 3L19 7M19 7L15 6.5M19 7L14.5 1.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ExchangeIcon: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 22C6.977 22 2.5 17.523 2.5 12C2.5 6.477 6.977 2 12.5 2C18.023 2 22.5 6.477 22.5 12C22.5 17.523 18.023 22 12.5 22ZM12.5 9H8.5V11H17.5L12.5 6V9ZM7.5 13L12.5 18V15H16.5V13H7.5Z"
        fill="white"
      />
    </svg>
  );
};

export const CoinIcon: FunctionComponent<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 14C11.8137 14 14.5 11.3137 14.5 8C14.5 4.68629 11.8137 2 8.5 2C5.18629 2 2.5 4.68629 2.5 8C2.5 11.3137 5.18629 14 8.5 14Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.59 10.37C19.5353 10.7224 20.3765 11.3075 21.0358 12.0712C21.695 12.8349 22.1511 13.7524 22.3617 14.7391C22.5724 15.7257 22.5309 16.7495 22.241 17.7158C21.9512 18.6822 21.4223 19.5598 20.7034 20.2676C19.9845 20.9754 19.0987 21.4905 18.128 21.7652C17.1572 22.04 16.1329 22.0655 15.1497 21.8395C14.1665 21.6134 13.2561 21.1431 12.5028 20.472C11.7495 19.8009 11.1776 18.9507 10.84 18M7.5 6H8.5V10"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.21 13.8799L17.91 14.5899L15.09 17.4099"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SecureIcon: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5 18H15.32C15.1707 17.5806 14.9299 17.1997 14.6151 16.8849C14.3003 16.5701 13.9194 16.3293 13.5 16.18V13H20.5C20.7652 13 21.0196 12.8946 21.2071 12.7071C21.3946 12.5196 21.5 12.2652 21.5 12C21.5 11.7348 21.3946 11.4804 21.2071 11.2929C21.0196 11.1054 20.7652 11 20.5 11H19.5V5C19.5 4.20435 19.1839 3.44129 18.6213 2.87868C18.0587 2.31607 17.2956 2 16.5 2H8.5C7.70435 2 6.94129 2.31607 6.37868 2.87868C5.81607 3.44129 5.5 4.20435 5.5 5V11H4.5C4.23478 11 3.98043 11.1054 3.79289 11.2929C3.60536 11.4804 3.5 11.7348 3.5 12C3.5 12.2652 3.60536 12.5196 3.79289 12.7071C3.98043 12.8946 4.23478 13 4.5 13H11.5V16.18C11.0806 16.3293 10.6997 16.5701 10.3849 16.8849C10.0701 17.1997 9.82932 17.5806 9.68 18H3.5C3.23478 18 2.98043 18.1054 2.79289 18.2929C2.60536 18.4804 2.5 18.7348 2.5 19C2.5 19.2652 2.60536 19.5196 2.79289 19.7071C2.98043 19.8946 3.23478 20 3.5 20H9.68C9.8902 20.5792 10.2736 21.0795 10.7782 21.4332C11.2827 21.7868 11.8839 21.9765 12.5 21.9765C13.1161 21.9765 13.7173 21.7868 14.2218 21.4332C14.7264 21.0795 15.1098 20.5792 15.32 20H21.5C21.7652 20 22.0196 19.8946 22.2071 19.7071C22.3946 19.5196 22.5 19.2652 22.5 19C22.5 18.7348 22.3946 18.4804 22.2071 18.2929C22.0196 18.1054 21.7652 18 21.5 18ZM7.5 11V5C7.5 4.73478 7.60536 4.48043 7.79289 4.29289C7.98043 4.10536 8.23478 4 8.5 4H16.5C16.7652 4 17.0196 4.10536 17.2071 4.29289C17.3946 4.48043 17.5 4.73478 17.5 5V11H7.5ZM12.5 20C12.3022 20 12.1089 19.9414 11.9444 19.8315C11.78 19.7216 11.6518 19.5654 11.5761 19.3827C11.5004 19.2 11.4806 18.9989 11.5192 18.8049C11.5578 18.6109 11.653 18.4327 11.7929 18.2929C11.9327 18.153 12.1109 18.0578 12.3049 18.0192C12.4989 17.9806 12.7 18.0004 12.8827 18.0761C13.0654 18.1518 13.2216 18.28 13.3315 18.4444C13.4414 18.6089 13.5 18.8022 13.5 19C13.5 19.2652 13.3946 19.5196 13.2071 19.7071C13.0196 19.8946 12.7652 20 12.5 20Z"
        fill="white"
      />
    </svg>
  );
};

export const KeyIcon: FunctionComponent<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 16C11.5 16.6 11.1 17 10.5 17C9.9 17 9.5 16.6 9.5 16C9.5 15.4 9.9 15 10.5 15C11.1 15 11.5 15.4 11.5 16ZM20.5 8V20C20.5 21.1 19.6 22 18.5 22H6.5C5.4 22 4.5 21.1 4.5 20V4C4.5 2.9 5.4 2 6.5 2H14.5M18.5 15H13.3C12.7 13.4 11 12.6 9.5 13.2C7.9 13.8 7.1 15.5 7.7 17C8.3 18.5 10 19.4 11.5 18.8C12.4 18.5 13 17.8 13.3 17H14.5V19H16.5V17H18.5M19 9L13.5 3.5V9H19Z"
        fill="white"
      />
    </svg>
  );
};

const featureList = [
  {
    Icon: BridgeIcon,
    title: "Bridge Web2 data and Web3 ",
    desc: "Create verifiable credentials of your Web2 data",
  },
  {
    Icon: AuthIcon,
    title: "Authorization",
    desc: "Authorize your data with confidence. Similar to the oAuth Flow",
  },
  {
    Icon: ExchangeIcon,
    title: "Data Sharing and Trading",
    desc: "Exchange values with the Network by providing data and interacting",
  },
  {
    Icon: CoinIcon,
    title: "Dual-NFT Token Design",
    desc: "Two NFT roles, one network",
  },
  {
    Icon: SecureIcon,
    title: "Secured by MPC",
    desc: "Access control secured by smart contract and MPC together",
  },
  {
    Icon: KeyIcon,
    title: "Sign in with Ethereum",
    desc: "Data ownership, protected with your Ethereum wallet",
  },
];

const FeaturesIntro: FunctionComponent = () => {
  return (
    <div className="layout-content bg-[#202020] py-12 sm:py-20 px-8 sm:px-[143px]">
      <div className="layout-block grid grid-cols-2 gap-x-8 gap-y-10 sm:grid-cols-3 sm:gap-x-[140px] sm:gap-y-20 text-white">
        {featureList.map((feature, index) => {
          return (
            <div key={index}>
              <feature.Icon></feature.Icon>
              <div className="sm:text-headerL font-semibold mt-1 h-[32px] sm:h-auto">
                {feature.title}
              </div>
              <div className="opacity-[0.85] mt-4 leading-tight">
                {feature.desc}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FeaturesIntro;
